import { Button, Separator } from "@dune/ui";
import { ArrowRight } from "lucide-react";
import { useFormContext } from "react-hook-form";
import GFAExperiencesContainer from "../../component/gfa/GFAExperiencesContainer";
import GFARealEstateSocietyContainer from "../../component/gfa/GFARealEstateSocietyContainer";
import GFAShareholdersContainer from "../../component/gfa/GFAShareholdersContainer";
import { GFAShareholdersAndExperiencesFormData } from "../../component/gfa/useGFAShareholdersAndExperiencesForm";

interface GFAShareholdersAndExperiencesFormProps {
	onSubmit: (
		data: GFAShareholdersAndExperiencesFormData & { isNext?: boolean },
	) => void;
}

const GFAShareholdersAndExperiencesForm = ({
	onSubmit,
}: GFAShareholdersAndExperiencesFormProps) => {
	const {
		getValues,
		trigger,
		formState: { isValid },
		handleSubmit,
	} = useFormContext<GFAShareholdersAndExperiencesFormData>();
	return (
		<div className="flex items-center justify-center p-6 w-full">
			<form
				onSubmit={handleSubmit(onSubmit)}
				className="flex-3 flex-col items-center justify-center p-4 w-full"
			>
				<div className="flex flex-col gap-6 w-full">
					<div className="flex flex-row gap-4">
						<h1 className="text-[#144C65] text-2xl font-medium">
							Actionnariat & Expérience
						</h1>
					</div>
					<GFARealEstateSocietyContainer />
					<Separator />
					<GFAShareholdersContainer />
					<Separator />
					<GFAExperiencesContainer />
					<Separator />

					{/* Action buttons */}
					<div className="self-end flex flex-row gap-4">
						<Button
							className="self-end"
							type="button"
							variant="outline"
							onClick={() => {
								trigger();
								if (isValid) {
									onSubmit?.({
										...getValues(),
										isNext: false,
									});
								}
							}}
						>
							Enregistrer et fermer
						</Button>
						<Button
							className="self-end"
							type="button"
							variant="default"
							onClick={() => {
								trigger();
								if (isValid) {
									onSubmit?.({
										...getValues(),
										isNext: true,
									});
								}
							}}
						>
							Suivant
							<ArrowRight className="w-4 h-4" />
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default GFAShareholdersAndExperiencesForm;
